module.exports = __webpack_public_path__ + "img/favorite-filling.7b223c43.svg";